module.exports = __webpack_public_path__ + "static/media/icon_projects.d6e5c4b2.svg";